import { State, initialState } from './state';
import { Actions, ActionTypes } from './actions';

export function eventLogReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.WARNING:
      return {
        ...state,
        messages: state.messages.concat({
          message:
            typeof action.payload === 'string'
              ? action.payload
              : action.payload.message,
          unread: true,
          warning: true,
        }),
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        messages: state.messages.concat({
          message:
            typeof action.payload === 'string'
              ? action.payload
              : action.payload.message,
          unread: true,
          success: true,
        }),
      };

    case ActionTypes.INFO:
      return {
        ...state,
        messages: state.messages.concat({
          message:
            typeof action.payload === 'string'
              ? action.payload
              : action.payload.message,
          unread: true,
          info: true,
        }),
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        messages: state.messages.concat({
          message:
            typeof action.payload === 'string'
              ? action.payload
              : action.payload.message,
          unread: true,
          error: true,
        }),
      };

    case ActionTypes.CLEAR:
      return {
        ...state,
        messages: [],
      };

    default: {
      return state;
    }
  }
}
